function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFAF20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.64 1.057c.778 0 1.41.677 1.41 1.509v6.548c0 .832-.632 1.509-1.41 1.509h-4.06v12.655H6.327V10.623H2.366c-.779 0-1.412-.677-1.412-1.509V2.566c0-.832.633-1.509 1.412-1.509h21.273zm-4.938 5.989H7.213v3.577h-.008V22.34h11.497V7.046zm4.937-5.05H2.366c-.294 0-.534.256-.534.57v6.548c0 .315.24.57.534.57h3.961V7.029H4.87c-.243 0-.44-.21-.44-.469 0-.26.197-.47.44-.47h16.176c.242 0 .439.21.439.47s-.197.47-.439.47h-1.457v2.656h4.05c.294 0 .534-.256.534-.57v-6.55c0-.313-.24-.57-.534-.57z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.548 19.147c0 .242.184.438.41.438.226 0 .41-.196.41-.438v-6.12l2.037 2.223a.396.396 0 0 0 .292.132c.106 0 .21-.044.287-.125a.46.46 0 0 0 .006-.62l-2.74-2.988-.015-.015.023.024-.043-.041c-.01-.01-.01-.01-.031-.026l-.033-.02-.04-.02-.034-.013c-.002 0-.002 0 0 0l-.003-.001c-.01-.004-.01-.004-.037-.01l-.038-.006-.041-.003c-.026.001-.026.001-.037.003l-.04.005-.037.01a.111.111 0 0 0-.003.001l-.003.001-.034.012c-.023.011-.023.011-.034.018l-.022.012c-.039.028-.039.028-.048.037l-.003.002-.01.01-.024.025-2.737 2.984a.46.46 0 0 0 .006.619l.145-.158-.145.158c.078.08.18.125.287.125.109 0 .214-.047.292-.132l2.037-2.222v6.119z"
})));

var SvgDepositBilletIcon = function SvgDepositBilletIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    style: {
      background: "#fff"
    },
    viewBox: "0 0 26 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDepositBilletIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/deposit_billet_icon.c6172d7c.svg";
export { ForwardRef as ReactComponent };